





























































import { defineComponent, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRoute } from "@/hooks/use-router";

export default defineComponent({
  setup() {
    const {
      store: { getters }
    } = useVuex();
    const route = useRoute();

    const disabled = computed(() => route.value.path === "/welcome");

    return {
      wallet: computed(() => getters.Wallet.wallet),
      disabled
    };
  }
});
